"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@instructure/ui-buttons/lib/components/Button"));

var _ScreenReaderContent = _interopRequireDefault(require("@instructure/ui-a11y/lib/components/ScreenReaderContent"));

var _IconArrowOpenStart = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconArrowOpenStart"));

var _IconArrowOpenEnd = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconArrowOpenEnd"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'dfDow',
  template: function template(theme) {
    return "\n\n.dfDow_bGBk{align-items:center;box-sizing:border-box;color:".concat(theme.color || 'inherit', ";display:flex;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";justify-content:space-between;padding:0 0.125rem}\n\n.dfDow_eCxz{font-size:").concat(theme.buttonIconSize || 'inherit', "}");
  },
  'root': 'dfDow_bGBk',
  'arrowIcon': 'dfDow_eCxz'
};
var DatePickerPagination = (
/**
---
parent: DatePicker
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DatePickerPagination, _Component);

  function DatePickerPagination() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DatePickerPagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DatePickerPagination)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handlePrevClick = function (e) {
      _this.props.onPrev(e);
    };

    _this.handleNextClick = function (e) {
      _this.props.onNext(e);
    };

    return _this;
  }

  (0, _createClass2.default)(DatePickerPagination, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: styles.root
      }, _react.default.createElement(_Button.default, {
        variant: "icon",
        onClick: this.handlePrevClick,
        icon: _react.default.createElement(_IconArrowOpenStart.default, {
          className: styles.arrowIcon
        })
      }, _react.default.createElement(_ScreenReaderContent.default, null, this.props.previousLabel)), this.props.children, _react.default.createElement(_Button.default, {
        variant: "icon",
        onClick: this.handleNextClick,
        icon: _react.default.createElement(_IconArrowOpenEnd.default, {
          className: styles.arrowIcon
        })
      }, _react.default.createElement(_ScreenReaderContent.default, null, this.props.nextLabel)));
    }
  }]);
  DatePickerPagination.displayName = "DatePickerPagination";
  return DatePickerPagination;
}(_react.Component), _class2.propTypes = {
  previousLabel: _propTypes.default.string.isRequired,
  nextLabel: _propTypes.default.string.isRequired,
  onPrev: _propTypes.default.func.isRequired,
  onNext: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
}, _class2.defaultProps = {
  children: null
}, _temp)) || _class);
exports.default = DatePickerPagination;